import { Atom } from 'AppReact';
import styled, { css } from "styled-components";
const template = styled.div`
    ${({ theme, displayState }) => {

        return css`
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        text-align: ${displayState?.textAlignment};
        letter-spacing: 0.01em;
        color: #7D7D7D;
        max-height: 400px;
        overflow: auto;
    `}
  }`;


export default Atom({ type: 'label', dataType: 'string', template })
